/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {initiateBitcoinWithdrawal} from '../api'

export const useMutationInitiateBitcoinWithdrawal = createReactQueryMutationHook('initiateBitcoinWithdrawal', initiateBitcoinWithdrawal)
